import styled, { css } from 'styled-components/macro';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { colorBrandYamahaRed, colorCoreBlack300, colorCoreBlack900Base, colorCoreGray500, colorCoreWhite1000, colorWhiteTransparent200, } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { getTextStyles } from '@yme/utils/styles';
import { DARK_ACCORDION } from './constants';
export const SVGIconToggle = styled(SVGIcon) ``;
export const AccordionItemContainer = styled.div `
  border-top: 1px solid ${colorCoreGray500};

  &:last-child {
    border-bottom: 1px solid ${colorCoreGray500};
  }

  h3 {
    padding: 0;
  }
`;
export const ButtonStyled = styled.button `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;

  background-color: transparent;
  border: none;
  width: 100%;

  cursor: pointer;

  ${SVGIconToggle} {
    path {
      transform-origin: center;
      transition: transform 0.3s;
      fill: ${colorCoreBlack900Base};
    }
  }

  ${({ isShowed }) => isShowed &&
    css `
      ${SVGIconToggle} {
        path {
          transform: rotate(45deg);
        }
      }
    `};
`;
export const TitleStyled = styled.span `
  ${getTextStyles('Ubuntu', 500, 16, 24)}

  ${({ isRightToLeft }) => isRightToLeft ? `padding-left: ${INDENT.xxxs};` : `padding-right: ${INDENT.xxxs};`}

  text-align: ${({ isRightToLeft }) => (isRightToLeft ? 'right' : 'left')};

  word-break: break-word;
  color: ${colorCoreBlack900Base};
`;
export const AlwaysActiveMarkStyled = styled.span `
  ${getTextStyles('Ubuntu', 400, 16, 24)}

  color: ${colorBrandYamahaRed};

  ${ADAPTIVE.minWidth.tablet} {
    ${getTextStyles(null, null, 18, null)}
  }
`;
export const LayoutStyled = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  button {
    -webkit-tap-highlight-color: transparent;
  }
`;
export const ContentStyled = styled.div `
  display: ${({ isShowed }) => (!isShowed ? 'none' : 'block')};

  padding-bottom: 24px;

  ${({ isContentStylesCustom }) => !isContentStylesCustom &&
    css `
      ${getTextStyles('Ubuntu', 400, 16, 24)}

      color: ${colorCoreBlack300};

      p {
        ${getTextStyles('Ubuntu', 400, 16, 24)}

        color: ${colorCoreBlack300};
      }
    `}
`;
export const AccordionContainer = styled.div `
  ${({ hasContainerPadding = true }) => hasContainerPadding &&
    css `
      padding: ${INDENT.xl} 0;

      ${ADAPTIVE.maxWidth.mobile} {
        padding: ${INDENT.sm} 0;
      }
    `};

  ${({ colorScheme }) => colorScheme === DARK_ACCORDION &&
    css `
      ${AccordionItemContainer} {
        border-color: ${colorWhiteTransparent200};

        svg {
          path {
            fill: ${colorCoreWhite1000};
          }
        }
      }

      ${TitleStyled} {
        color: ${colorCoreWhite1000};
      }

      ${ContentStyled} {
        color: ${colorCoreWhite1000};
      }
    `}

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}
`;
